import {CommonModule} from '@angular/common';
import {Component} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelectModule} from '@angular/material/select';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslateModule} from '@ngx-translate/core';
import {SharedFilterModule} from '@progress/kendo-angular-grid';
import {FilterOperator} from '@progress/kendo-data-query';
import {Q9TrimValueDirective} from '@q9elements/ui-kit/common';
import {
  DatetimePickerComponent,
  GridFilterOperatorSelectComponent,
  IconButtonComponent,
  TagsComboboxModule,
  pickFilterOperators
} from '@q9elements/ui-kit/components';
import {AlertOperatorsByTypeMapping} from '../../../../models/consts/AlertOperatorByTypeMapping';
import {RmeBaseGridFilterComponent} from '../rme-base-grid-filter/rme-base-grid-filter.component';

/**
 * Alerts-table header filter. Identical to `RmeBaseGridFilterComponent` except the
 * operator menu is restricted (see `AlertOperatorsByTypeMapping`).
 * Reuses the base template, styles.
 */
@Component({
  standalone: true,
  selector: 'app-alert-grid-filter',
  templateUrl: '../rme-base-grid-filter/rme-base-grid-filter.component.html',
  imports: [
    CommonModule,
    MatInputModule,
    MatAutocompleteModule,
    FormsModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    Q9TrimValueDirective,
    SharedFilterModule,
    MatSelectModule,
    TranslateModule,
    GridFilterOperatorSelectComponent,
    MatTooltipModule,
    IconButtonComponent,
    TagsComboboxModule,
    DatetimePickerComponent
  ],
  styleUrls: ['../rme-base-grid-filter/rme-base-grid-filter.component.scss']
})
export class AlertGridFilterComponent extends RmeBaseGridFilterComponent {
  protected override resolveOperators(): Array<{value: FilterOperator; label: string}> {
    const restricted = AlertOperatorsByTypeMapping[this.filterType];

    return restricted ? pickFilterOperators(restricted) : super.resolveOperators();
  }

  /**
   * The alerts table renders a dynamical view, so `customViewService.selectedView` is never
   * populated and the base lookup of the current column would throw. All alert columns are
   * filter-editable, so mark editable unconditionally.
   */
  protected override checkIfCanEditFilter(): void {
    this.editable.set(true);
  }
}
